<app-confirmation-dialog
  [height]="'auto'"
  [showModal]="showModal"
  (showModalChange)="onShowModalChange($event)"
  (submit)="onDecline()"
  [options]="declineTrainingModalOptions"
></app-confirmation-dialog>